import { Table } from '../../../../core-ui/Table'
import { drawerFilters, getColumns } from './helpers'
import { useMemo, useState } from 'react'
import { makeCoreGetFileRequest, makeCoreGetRequest } from '../../../../../utils/api'
import { toTableGETUrl } from '../../../../core-ui/Table/serializers'
import { toTableRowItems } from './serializers'
import { formatErrorMessage, parseBlobErrorResponse } from "../../../../../utils/formatting";
import { useNotification } from '../../../../../hooks'
import { useNavigate } from 'react-router-dom'
import s from '../../../commonStyles.modules.scss'
import { formatAndDownloadResponse } from 'utils/helpers'
import { getDepositNameOptions, getShopOptions } from '../../api'

const SupportWrongDestination = ({ isHistorical }) => {
  const { showNotification } = useNotification()
  const navigate = useNavigate()
  const [tableItems, setTableItems] = useState<SupportWrongDestination[]>([])
  const [totalCount, setTotalCount] = useState<number>(0)
  const [isLoading, setIsLoading] = useState<boolean>(false)
  const [shouldRefreshData, setShouldRefreshData] = useState<boolean>(false)

  const { data: depositOptions } = getDepositNameOptions(showNotification)
  const { data: shopOptions } = getShopOptions(showNotification)

  const downloadFile = async id => {
    try {
      let url = isHistorical
        ? '/shop-reception/wrongDestinationArchive'
        : '/shop-reception/wrongDestination'
      const response = await makeCoreGetFileRequest(`${url}/download/${id}`, {
        responseType: 'blob'
      })
      return formatAndDownloadResponse(response)
    } catch (error) {
      const errorMessage = await parseBlobErrorResponse(error);

      showNotification({
        message: errorMessage,
        type: 'error'
      });
    }
  }

  const columns = useMemo(() => getColumns(navigate, downloadFile, isHistorical), [isHistorical])

  const fetchData = async ({ page, rowsPerPage, order, orderBy, tableFilters }) => {
    setIsLoading(true)
    try {
      const response = await makeCoreGetRequest(
        toTableGETUrl({
          url: isHistorical
            ? '/shop-reception/wrongDestinationArchive'
            : '/shop-reception/wrongDestination',
          tableFilters,
          page,
          rowsPerPage,
          order,
          orderBy
        })
      )

      setTableItems(toTableRowItems(response.deliverySupportList))
      setTotalCount(response.page.totalCount)
      setIsLoading(false)
    } catch (error) {
      showNotification({
        message: `A aparut o eroare la obtinerea datelor din tabel. ${formatErrorMessage(error)}`,
        type: 'error'
      })
      setIsLoading(false)
    }
  }

  return (
    <div className={s.mainContainer}>
      <Table
        hideCheckbox
        columns={columns}
        items={tableItems}
        fetchData={fetchData}
        isLoading={isLoading}
        totalCount={totalCount}
        shouldRefreshData={shouldRefreshData}
        setShouldRefreshData={setShouldRefreshData}
        filters={drawerFilters(depositOptions, shopOptions)}
        filtersLabel="Filtreaza"
        filtersButtonLabel="Filtreaza"
        appliedFiltersLabel="Filtre"
        cancelFiltersButtonLabel="Anuleaza"
        applyFiltersButtonLabel="Aplica"
        rowsPerPage={10}
        rowsPerPageOptions={[10, 25, 50]}
      />
    </div>
  )
}

export default SupportWrongDestination
